import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AppLayoutService } from '@app/modules/app-layout/app-layout.service';

@Component({
  selector: 'user-update',
  templateUrl: './user-update.component.html',
  styleUrls: ['./user-update.component.scss'],
})
export class UserUpdateComponent implements OnInit {
  public initialSection: string;

  private returnUrl: string;

  constructor(private router: Router, private route: ActivatedRoute, private appLayoutService: AppLayoutService) {
    this.appLayoutService.contentHeader$.next({ title: [{ key: 'MENU.ACCOUNT', link: null }] });
  }

  public ngOnInit(): void {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'];
    if (this.route.snapshot.queryParams['section']) {
      this.initialSection = this.route.snapshot.queryParams['section'];
    }
  }

  public save() {
    if (!!this.returnUrl) {
      this.router.navigateByUrl(decodeURI(this.returnUrl));
      return;
    }
    this.router.navigate(['dashboard']);
  }

  public goToLoginPage() {
    this.router.navigate(['auth', 'login']);
  }

  public navigateToElement(id: string) {
    const element: HTMLElement = document.getElementById(id?.replace('#', ''));

    if (element) {
      setTimeout(() => element.scrollIntoView({ behavior: 'smooth', block: 'center' }));
    }
  }
}
